const $ = require('jquery');

const Ui = require('./Ui');
const File = require('../data/File');
const i18next = require('i18next');
const constants = require('../data/constants');

class FileUpload {
  /**
   * Listens to the Upload File form and processes it
   *
   * @param {Files} files
   * @param {Api} api
   * @param {String} sessionId
   * @param {Preloader} preloader
   * @param {Function} callback
   */
  constructor(files, sessionId, api, preloader, callback) {
    this._files = files;
    this._api = api;
    this._sessionId = sessionId;
    this._preloader = preloader;
    this._file = null;
    this._callback = callback;
    this._fileData = null;
    this._fileName = null;
    this._uploadForm = $('.formUpload');
    this._uploadButton = $('#btnUpload');
    this._uploadFileNameInput = $('#uploadName');
    this._uploadFileName = $('.title-file');
    this._modal = $('.modal-upload');
    this._fileUploadContainer = $('.fileupload-container');
  }

  init() {
    this.addListeners();
  }

  processUploadForm() {
    this._preloader.showCursorPreloader();

    const name = this._uploadFileNameInput.val();
    const { files } = this._files;
    const fileExists = files.find((file) => { // eslint-disable-line
      return file.name.toLowerCase() === name.toLowerCase();
    });

    if (fileExists) {
      this.showError(i18next.t("errors.file-already-exists", {fileName: name }), true);
      return;
    }

    if (this._fileData.length === 0) {
      this.showError(i18next.t('errors.uploaded-file-empty'), true);
      return;
    }

    try {
      const file = File.deserialize(this._fileData);
      if (!file.name || !(Array.isArray(file.segments))) {
        // noinspection ExceptionCaughtLocallyJS
        throw new Error(i18next.t('errors.uploaded-file-invalid'));
      }

      // noinspection JSCheckFunctionSignatures
      this._api.createFile(this._sessionId, name)
        .then((savedFile) => {
          this._file = savedFile;

          let bulkSegments = this.createBulkSegmentBody(file.segments);

          this._api.uploadBulkSegments(this._sessionId, bulkSegments, this._file.id)
            .then((response) => {

              this._api.getFileList(this._sessionId)
                .then(files => {
                  let syncFile = files.getByFileId(this._file.id);
                  this._files.add(syncFile);
                  this._callback(syncFile);
                  this._modal.modal('hide');
                });

            })
            .catch(error => {
              //console.log("uploadBulk catch");
              console.log(error)
            });
        })
        .catch((reason) => {
          if(reason._code === "6001") {
            this.showError(i18next.t("errors.could-not-upload", {fileName: name}) , true);
          } else {
            console.log(reason);
          }
        });
    } catch (e) {
      this.showError(i18next.t('errors.uploaded-file-decode'), true);
      console.error(e);
    }

    $('.formUpload')[0].reset();
  }

  readFile(file, onLoadCallback) {
    this._fileName = file.name;

    const reader = new FileReader();
    reader.onload = onLoadCallback;
    reader.readAsText(file);
  }

  createBulkSegmentBody(segments) {
    return segments.map((segment) => {

      let modStreetAttributes = [];

      let attributes = Object.keys(segment.attributes).forEach(attribute => {
        if(attribute === constants.SEGMENT_MODIFIED_STREET) {
          let keys = Object.keys(segment.attributes[constants.SEGMENT_MODIFIED_STREET]);
          modStreetAttributes = keys.map(modStreetAttribute => {
            return {
              name: modStreetAttribute,
              value: segment.attributes[constants.SEGMENT_MODIFIED_STREET][modStreetAttribute]
            }
          })
        }
      });

      let validity = segment.attributes.validity ? segment.attributes.validity : 0;

      let bulkSegment = {
        coordinates: segment.coordinates.map((coord) => {
          return {
            lat: coord.getY(),
            lon: coord.getX()
          }
        }),
        openlr: segment.olr,
        attributes: Object.keys(segment.attributes).filter(attribute => attribute !== constants.SEGMENT_MODIFIED_STREET && attribute !== 'validity').map(attribute => {

         if(attribute === "detourEditor_turnArrowCoords") {
            let arrowCoords = "";
            segment.attributes.detourEditor_turnArrowCoords.forEach(iwCoordinate => {
              arrowCoords += `${iwCoordinate.getX()},${iwCoordinate.getY()};`
            });

           arrowCoords = arrowCoords.slice(0, -1);

            return {
              name: attribute,
              value: arrowCoords
            }
          } else {
            return {
              name: attribute,
              value: segment.attributes[attribute].toString()
            }
          }
        })
      };

      modStreetAttributes.forEach(att => {
        bulkSegment.attributes.push(att);
      });

      bulkSegment.attributes.push({name: 'validity', value: validity});

      if(bulkSegment.coordinates.length <= 0) {
        bulkSegment.coordinates.push({
          lat: 0,
          lon: 0
        })
      }

      return bulkSegment
    });
  }

  addListeners() {
    // noinspection JSUnresolvedFunction
    $('#fileupload').on('change', (element) => {
      this.readFile(element.target.files[0], (event) => {
        this._fileData = event.target.result;

        const filename = this.decomposeFileName();
        this._uploadFileName.html(this._fileName);
        this._uploadFileNameInput.val(filename.name);
        this._uploadButton.prop('disabled', false);
      });
    });

    // noinspection JSUnresolvedFunction
    this._uploadButton.on('click', (event) => {
      event.preventDefault();
      this._uploadForm.trigger('submit');
    });

    // noinspection JSUnresolvedFunction
    this._uploadForm.on('submit', (event) => {
      event.preventDefault();
      this.processUploadForm();
    });

    // noinspection JSUnresolvedFunction
    this._modal.on('show.bs.modal', () => {
      this._fileUploadContainer.attr("data-content",this._api.localization.translate("editor.upload-file"));
      this._uploadButton.prop('disabled', true);
      this._uploadFileName.html('');
      this._uploadFileNameInput.val('');
    });
  }

  showError(errorMessage, stop) {
    Ui.showModalError(errorMessage);

    if (stop) {
      this._preloader.hideCursorPreloader();
    }
  }

  /**
   * @function splits a filename into name and extension
   *
   * Shifting the bits for when lastIndexOf is negative will return a
   * much higher value (eg 4294967295 for -1). This helps
   * ignoring dotfiles, like .htaccess
   *
   * @returns Object
   */
  decomposeFileName() {
    // eslint-disable-next-line
    const extension = this._fileName.slice((this._fileName.lastIndexOf('.') - 1 >>> 0) + 2);

    return {
      name: this._fileName.replace(`.${extension}`, ''),
      extension,
    };
  }
}

module.exports = FileUpload;
